import React, { useState } from 'react';
import TitleBar from 'src/components/layout/TitleBar';
import { LOCAL_STORAGE_KEYS } from 'src/misc/Config';
import { MdSecurity } from 'react-icons/md';
import { Space } from 'antd';
import DraggableLayoutProvider from 'src/components/layout/DraggableLayoutProvider';
import DraggableLayoutItem from 'src/components/layout/DraggableLayoutItem';
import RiskLevel from './Components/RiskLevel';
import RiskLevelHistory from './Components/RiskLevelHistory';
import WorkersHistory from './Components/WorkersHistory';
import Controls from './Components/Controls';
import { MdOutlineTrendingDown, MdHistory, MdOutlineSecurity, MdWarning } from 'react-icons/md';
import { IoMdPlay } from 'react-icons/io';
import EventsWidget from './Components/Events/EventsWidget';
import EventsWidgetBtns from './Components/Events/EventsWidgetBtns';
import EventsSetup from './Components/Events/EventsSetup';
import JobLoader from './Components/JobLoader';
//import PropTypes from 'prop-types';

const Dashboard = () => {
  const componentsGallery = [
    {
      id: 'Risk Level',
      col: 0,
      component: (
        <DraggableLayoutItem
          title={
            <Space className='btn'>
              <MdOutlineSecurity />
              Risk Level
            </Space>
          }
          centered
        >
          <RiskLevel />
        </DraggableLayoutItem>
      ),
      permissions: ['apps.securityadvisor.view'],
    },
    {
      id: 'Control Panel',
      col: 0,
      component: (
        <DraggableLayoutItem
          title={
            <Space className='btn'>
              <IoMdPlay />
              Controls
            </Space>
          }
          centered
        >
          <Controls />
        </DraggableLayoutItem>
      ),
      permissions: ['apps.securityadvisor.view'],
    },
    {
      id: 'Trend',
      col: 1,
      component: (
        <DraggableLayoutItem
          title={
            <Space className='btn'>
              <MdOutlineTrendingDown />
              Trend
            </Space>
          }
          centered
        >
          <RiskLevelHistory />
        </DraggableLayoutItem>
      ),
      permissions: ['apps.securityadvisor.view'],
    },
    {
      id: 'History',
      col: 1,
      component: (
        <DraggableLayoutItem
          title={
            <Space className='btn'>
              <MdHistory />
              History
            </Space>
          }
          centered
        >
          <WorkersHistory />
        </DraggableLayoutItem>
      ),
      permissions: ['apps.securityadvisor.view'],
    },
    {
      id: 'Notifications',
      col: 1,
      component: (
        <DraggableLayoutItem
          title={
            <Space className='btn'>
              <MdWarning />
              Notifications
            </Space>
          }
          centered
          titleExtras={<EventsWidgetBtns />}
        >
          <EventsSetup>
            <EventsWidget />
          </EventsSetup>
        </DraggableLayoutItem>
      ),
      permissions: ['apps.securityadvisor.view'],
    },
  ];

  const [layoutItemsSelector, setLayoutItemsSelector] = useState(null);

  return (
    <>
      <TitleBar
        title={
          <Space className='btn'>
            <MdSecurity />
            Security Advisor
            <span className='font-thin'>Dashboard</span>
          </Space>
        }
      >
        {layoutItemsSelector}
      </TitleBar>
      <JobLoader>
        <DraggableLayoutProvider getLayoutItemsSelector={(layoutItemsSelector) => setLayoutItemsSelector(layoutItemsSelector)} columns={2} mainColumnIndex={1} componentsGallery={componentsGallery} layoutKey={LOCAL_STORAGE_KEYS.layoutSecurityAdvisor} layoutHiddenKey={LOCAL_STORAGE_KEYS.layoutSecurityAdvisorHidden} />
      </JobLoader>
    </>
  );
};

// HomeMasterAdmin.propTypes = {};

export default Dashboard;
